<template>
    <div class="reservation-payment">
        <section class="container-fluid bg-white mp__reservations mp__nav" style="color: var(--blue);">
            <div class="container py-4">
                <div class="head gap-4 d-flex align-items-center">
                    <router-link :to="'/machupicchu'" class="backed">
                        <Arrow />
                    </router-link>
                    <div>
                        <h2 class="mb-2">
                            Contáctanos
                        </h2>
                    </div>
                </div>
            </div>
        </section>
        <div class="my-5 py-5 px-4 bg-white container form-contact-us">
            <div>
                <h5>
                    Formulario de contacto
                </h5>
            </div>
            <div class="pt-4">
                <div class="row pb-4">
                    <div class="col-6">
                        <div class="mp-form-text">
                        <div class="input-container">
                            <input type="text" name="name" v-model="form.name" required />
                            <label>Nombre del solicitante</label>
                        </div>
                        </div>
                    </div>
                    <div class="col-6">
                        <div class="mp-form-text">
                        <div class="input-container">
                            <input type="text" value="" name="phone" v-model="form.phone" required />
                            <label>Teléfono de contacto</label>
                        </div>
                        </div>
                    </div>
                </div>
                <div class="row pb-4">
                    <div class="mp-form-select col-12">
                        <div class="select-container" style="margin-bottom: 0px"
                            :class="{
                                error: error.typeMessage,
                            }">
                            <select
                                v-model="form.typeMessage"
                                onclick="this.setAttribute('data-value', this.value);"
                                onchange="this.setAttribute('data-value', this.value);"
                                :data-value="form.typeMessage"
                                @change="changeErrorField('typeMessage')"
                                name="typeMessage"
                            >
                                <option value="" selected></option>
                                <option v-for="(item, index) in typeMessages" :key="index" 
                                    :value="item.value">
                                    {{ item.name }}
                                </option>
                            </select>
                            <label>Tipo de mensaje*</label>
                        </div>
                        <i v-if="error.typeMessage" class="validation error" style="font-style: normal">
                            *Campo obligatorio
                        </i>
                    </div>
                </div>
                <div class="row pb-4">
                    <div class="col-6">
                        <div class="mp-form-text">
                            <div class="input-container"
                                :class="{
                                    error: error.subject,
                                }">
                                <input type="text" name="subject" v-model="form.subject"
                                    @input="changeErrorField('subject')"
                                    required />
                                <label>Asunto*</label>
                            </div>
                            <i v-if="error.subject" class="validation error" style="font-style: normal">
                                *Campo obligatorio
                            </i>
                        </div>
                    </div>
                    <div class="col-6">
                        <div class="mp-form-text">
                            <div class="input-container"
                                :class="{
                                    error: error.email,
                                }">
                                <input type="text" value="" name="email" v-model="form.email" 
                                    @input="changeErrorField('email')"
                                    required />
                                <label>Tu correo electrónico*</label>
                            </div>
                            <i v-if="error.email" class="validation error" style="font-style: normal">
                                *Campo obligatorio
                            </i>
                        </div>
                    </div>
                </div>
                <div class="row">
                    <div class="col-12">
                        <div class="mp-form-text">
                            <div class="input-container"
                                :class="{
                                    error: error.message,
                                }">
                                <textarea name="message"  value="" rows="3"                                
                                    @input="changeErrorField('message')"
                                    :maxlength="numberOfCharacters"
                                    v-model="form.message" />
                                <label>Tu mensaje*</label>
                            </div>
                            <i v-if="error.message" class="validation error" style="font-style: normal">
                                *Campo obligatorio
                            </i>
                        </div>
                        <div class="text-right">
                            <span style="font-size: 12px;font-weight: 500;color:var(--grayscale-400)">
                                {{form.message.length}}/{{ numberOfCharacters }}
                            </span>
                        </div>
                    </div>
                </div>
                <div>
                    <b-button class="mt-3 mp__btn" variant="outline-danger" block 
                        @click="sendInformation()">
                        Enviar mensaje
                    </b-button>
                </div>
            </div>
        </div>
        <loading :showModal="modalLoading.showModal" />
        <ReservationModal
            :showModal="modalInformation.showModal"
            :icon="modalInformation.icon"
            :title="modalInformation.title"
            :message="modalInformation.message"
            :buttonText="modalInformation.buttonText"
            @closeModalRegister="hideModal"
        />
    </div>
</template>
<script>
//import api from '@/api';
import 'vue2-datepicker/index.css';
import {Arrow} from '@/assets/icons';
export default {
  components: {
    Arrow,
    loading: () => import('@/components/modals/loading'),
  },
  data() {
    return {
        numberOfCharacters: 100,
        form:{
            name:'',
            phone:'',
            typeMessage:'',
            subject:'',
            email:'',
            message:'',
        },
        typeMessages:[
            {
                value:1,
                name:'Sugerencia'
            },
            {
                value:2,
                name:'Comentario'
            },
            {
                value:3,
                name:'Problema'
            },
            {
                value:4,
                name:'Otro'
            }
        ],
        modalInformation:{            
            showModal:false,
            icon:'check',
            title:'¡Mensaje enviado!',
            message:'Gracias por contactarnos. Hemos recibido tu mensaje, de ser necesario, nos contactaremos al correo brindado tan pronto sea posible.',
            buttonText:'Entendido',
        },
        modalLoading:{
            showModal:false,
        },
        error:{
            typeMessage:false,
            email:false,
            subject:false,
            message:false,
        },
    };
  },
  mounted() {
  },
  methods: {
    validateFields(){
        this.error.typeMessage = this.form.typeMessage.length === 0;
        this.error.email = this.form.email.length === 0;
        this.error.subject = this.form.subject.length === 0;
        this.error.message = this.form.message.length === 0;
        return  this.error.typeMessage || this.error.email 
            || this.error.subject || this.error.message
    },
    sendInformation(){
        if(!this.validateFields()){            
            this.modalLoading.showModal = true;
            setTimeout(() => {
                this.modalLoading.showModal = false;
                this.modalInformation.showModal = true;
            }, 3000);
        }
    },
    hideModal(){
        this.modalInformation.showModal = false;        
        this.form = {
            name:'',
            phone:'',
            typeMessage:'',
            subject:'',
            email:'',
            message:'',
        }
    },
    changeErrorField(field){
        this.error[field] = false;
    }
  },
};
</script>
<style lang="scss" scoped>
.form-contact-us{
    border-radius: 8px;
    color: var(--blue);
    h5{
        font-size: 20px;
        font-weight: 900;
        text-align: center;
        padding-bottom: 2rem;
        border-bottom: 2px solid var(--dove-gray-500);
    }
}
.head {
  .backed {
    background-color: transparent;
    padding: 1.5rem 1rem 1.5rem 0;
    border: none;
  }
  h2 {
    font-weight: 900;
    font-size: 1.5rem;
  }
  p {
    font-weight: 500;
    font-size: 1rem;
    margin-bottom: 0;
  }
}
</style>
